import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation - AI kelimesi kaldırıldı
      "nav.tarot": "Tarot",
      "nav.horoscope": "Horoscope",
      "nav.coffee": "Coffee Fortune",
      "nav.relationship": "Love Analysis",
      "nav.history": "My Readings",
      "nav.premium": "Get Credits",
      "nav.logout": "Logout",
      
      // Hero Section - AI kelimesi kaldırıldı
      "hero.title": "Mystic Tarot",
      "hero.subtitle": "Your Personal Fortune Companion",
      "hero.tagline": "Discover the hidden side of your destiny",
      "hero.cta": "Begin Your Journey",
      "hero.login": "Sign In",
      "hero.register": "Create Account",
      
      // Features - AI kelimesi kaldırıldı
      "features.coffee.title": "Coffee Fortune",
      "features.coffee.desc": "Ancient Turkish coffee reading with deep intuitive analysis",
      "features.relationship.title": "Love Analysis",
      "features.relationship.desc": "Discover the hidden side of your relationship with personalized insights",
      "features.tarot.title": "Tarot Reading",
      "features.tarot.desc": "Receive personalized tarot interpretations with deep spiritual insight",
      "features.horoscope.title": "Daily Horoscope",
      "features.horoscope.desc": "Your cosmic forecast tailored to your zodiac sign",
      
      // Auth
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.name": "Full Name",
      "auth.birthdate": "Birth Date",
      "auth.birthdateHint": "Day / Month / Year",
      "auth.birthdatePlaceholder": "Select your birth date (DD/MM/YYYY)",
      "auth.birthdateError": "Please select your birth date",
      "auth.zodiac": "Zodiac Sign",
      "auth.login": "Sign In",
      "auth.register": "Create Account",
      "auth.hasAccount": "Already have an account?",
      "auth.noAccount": "Don't have an account?",
      
      // Tarot
      "tarot.selectSpread": "Select Card Spread",
      "tarot.threeCard": "Three Card",
      "tarot.fiveCard": "Five Card",
      "tarot.tenCard": "Celtic Cross",
      "tarot.question": "Ask your question (optional)",
      "tarot.drawCards": "Draw Cards",
      "tarot.interpretation": "Interpretation",
      "tarot.newReading": "New Reading",
      
      // Horoscope
      "horoscope.selectSign": "Select Your Zodiac Sign",
      "horoscope.daily": "Daily",
      "horoscope.weekly": "Weekly",
      "horoscope.monthly": "Monthly",
      "horoscope.readNow": "Read Now",
      "horoscope.luckyNumber": "Lucky Number",
      "horoscope.luckyColor": "Lucky Color",
      "horoscope.luckyStone": "Lucky Stone",
      
      // Coffee
      "coffee.uploadImage": "Upload Coffee Cup Image",
      "coffee.dragDrop": "Drag & drop or click to upload",
      "coffee.analyze": "Analyze Fortune",
      "coffee.reading": "Fortune Reading",
      
      // Relationship - AI kelimesi kaldırıldı
      "relationship.title": "Love Analysis",
      "relationship.description": "Describe your relationship",
      "relationship.partnerDescription": "Describe your partner",
      "relationship.messages": "Share conversation examples (optional)",
      "relationship.situation": "Specific situation (optional)",
      "relationship.analyze": "Get Insights",
      "relationship.futureScenario": "Future Outlook",
      "relationship.infidelityRisk": "Trust Analysis",
      "relationship.relationshipMap": "Relationship Map",
      "relationship.redFlags": "Warning Signs",
      "relationship.messageAnalysis": "Communication Style",
      "relationship.solutionPlan": "Improvement Plan",
      "relationship.energyScore": "Energy Match",
      "relationship.partnerMirror": "Mirror Analysis",
      
      // Premium - YENİ LANSMAN PAKETİ
      "premium.title": "Mystic Credits",
      "premium.subtitle": "Unlock all mystical features with credits",
      "premium.feature1": "Personal tarot readings",
      "premium.feature2": "Daily horoscope insights",
      "premium.feature3": "Detailed coffee fortune",
      "premium.feature4": "Deep love analysis",
      "premium.feature5": "Ad-free experience",
      "premium.weekly": "Weekly",
      "premium.monthly": "Monthly",
      "premium.weeklyPrice": "₺59/week",
      "premium.monthlyPrice": "₺149/month",
      "premium.bestValue": "Best Value",
      "premium.cta": "Get Credits",
      "premium.note": "💳 Secure payment via Google Play",
      "premium.choosePlan": "Get More Credits",
      "premium.mostPopular": "Most Popular",
      "premium.unlimited": "Unlimited",
      "premium.creditsPerMonth": "credits",
      "premium.currentPlan": "Current Plan",
      "premium.selectPlan": "Select",
      
      // Credits
      "credits.remaining": "Credits",
      "credits.cost": "Cost",
      "credits.insufficient": "Insufficient credits",
      "credits.coffeeBlocked": "Coffee fortune requires credits",
      "credits.unlimited": "Unlimited",
      "credits.expiresIn": "Expires in",
      "credits.days": "days",
      
      // Common
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.back": "Back",
      "common.save": "Save",
      "common.cancel": "Cancel"
    }
  },
  tr: {
    translation: {
      // Navigation - AI kelimesi kaldırıldı
      "nav.tarot": "Tarot",
      "nav.horoscope": "Burç",
      "nav.coffee": "Kahve Falı",
      "nav.relationship": "İlişki Analizi",
      "nav.history": "Fallarım",
      "nav.premium": "Kredi Al",
      "nav.logout": "Çıkış",
      
      // Hero Section - AI kelimesi kaldırıldı
      "hero.title": "Mystic Tarot",
      "hero.subtitle": "Kişisel Fal Rehberiniz",
      "hero.tagline": "Kaderinizin gizli yönlerini keşfedin",
      "hero.cta": "Yolculuğa Başla",
      "hero.login": "Giriş Yap",
      "hero.register": "Kayıt Ol",
      
      // Features - AI kelimesi kaldırıldı, YENİ SIRALAMA
      "features.coffee.title": "Kahve Falı",
      "features.coffee.desc": "Derin sezgisel analiz ile geleneksel Türk kahvesi falı",
      "features.relationship.title": "İlişki Analizi",
      "features.relationship.desc": "İlişkinizin gizli yönlerini kişiye özel yorumlarla keşfedin",
      "features.tarot.title": "Tarot Falı",
      "features.tarot.desc": "Derin manevi içgörülerle kişiye özel tarot yorumları",
      "features.horoscope.title": "Günlük Burç",
      "features.horoscope.desc": "Burcunuza özel kozmik tahminler",
      
      // Auth
      "auth.email": "E-posta",
      "auth.password": "Şifre",
      "auth.name": "Ad Soyad",
      "auth.birthdate": "Doğum Tarihi",
      "auth.birthdateHint": "Gün / Ay / Yıl",
      "auth.birthdatePlaceholder": "Doğum tarihinizi seçin (GG/AA/YYYY)",
      "auth.birthdateError": "Lütfen doğum tarihinizi seçin",
      "auth.zodiac": "Burç",
      "auth.login": "Giriş Yap",
      "auth.register": "Kayıt Ol",
      "auth.hasAccount": "Zaten hesabınız var mı?",
      "auth.noAccount": "Hesabınız yok mu?",
      
      // Tarot
      "tarot.selectSpread": "Kart Dizilişi Seçin",
      "tarot.threeCard": "Üç Kart",
      "tarot.fiveCard": "Beş Kart",
      "tarot.tenCard": "Kelt Haçı",
      "tarot.question": "Sorunuzu sorun (opsiyonel)",
      "tarot.drawCards": "Kartları Çek",
      "tarot.interpretation": "Yorum",
      "tarot.newReading": "Yeni Fal",
      
      // Horoscope
      "horoscope.selectSign": "Burcunuzu Seçin",
      "horoscope.daily": "Günlük",
      "horoscope.weekly": "Haftalık",
      "horoscope.monthly": "Aylık",
      "horoscope.readNow": "Yorumu Oku",
      "horoscope.luckyNumber": "Şanslı Sayı",
      "horoscope.luckyColor": "Şanslı Renk",
      "horoscope.luckyStone": "Şanslı Taş",
      
      // Coffee
      "coffee.uploadImage": "Kahve Fincanı Fotoğrafı Yükle",
      "coffee.dragDrop": "Sürükle bırak veya tıkla",
      "coffee.analyze": "Falı Yorumla",
      "coffee.reading": "Fal Yorumu",
      
      // Relationship - AI kelimesi kaldırıldı
      "relationship.title": "İlişki Analizi",
      "relationship.description": "İlişkinizi tanımlayın",
      "relationship.partnerDescription": "Partnerinizi tanımlayın",
      "relationship.messages": "Konuşma örnekleri paylaşın (opsiyonel)",
      "relationship.situation": "Belirli bir durum (opsiyonel)",
      "relationship.analyze": "Analiz Et",
      "relationship.futureScenario": "Gelecek Senaryosu",
      "relationship.infidelityRisk": "Güven Analizi",
      "relationship.relationshipMap": "İlişki Haritası",
      "relationship.redFlags": "Uyarı İşaretleri",
      "relationship.messageAnalysis": "İletişim Tarzı",
      "relationship.solutionPlan": "Çözüm Planı",
      "relationship.energyScore": "Enerji Uyumu",
      "relationship.partnerMirror": "Ayna Analizi",
      
      // Premium - YENİ LANSMAN PAKETİ
      "premium.title": "Mystic Kredileri",
      "premium.subtitle": "Tüm mistik özelliklere kredi ile erişin",
      "premium.feature1": "Kişiye özel tarot yorumları",
      "premium.feature2": "Günlük burç öngörüleri",
      "premium.feature3": "Detaylı kahve falı",
      "premium.feature4": "Derin ilişki analizi",
      "premium.feature5": "Reklamsız deneyim",
      "premium.weekly": "Haftalık",
      "premium.monthly": "Aylık",
      "premium.weeklyPrice": "₺59/hafta",
      "premium.monthlyPrice": "₺149/ay",
      "premium.bestValue": "En İyi Değer",
      "premium.cta": "Kredi Al",
      "premium.note": "💳 Google Play üzerinden güvenli ödeme",
      "premium.choosePlan": "Kredi Satın Al",
      "premium.mostPopular": "En Popüler",
      "premium.unlimited": "Sınırsız",
      "premium.creditsPerMonth": "kredi",
      "premium.currentPlan": "Mevcut Plan",
      "premium.selectPlan": "Seç",
      
      // Credits
      "credits.remaining": "Kredi",
      "credits.cost": "Maliyet",
      "credits.insufficient": "Yetersiz kredi",
      "credits.coffeeBlocked": "Kahve falı için kredi gerekli",
      "credits.unlimited": "Sınırsız",
      "credits.expiresIn": "Kalan süre",
      "credits.days": "gün",
      
      // Common
      "common.loading": "Yükleniyor...",
      "common.error": "Bir hata oluştu",
      "common.back": "Geri",
      "common.save": "Kaydet",
      "common.cancel": "İptal"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'tr', // Default to Turkish
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    }
  });

// Sync with localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('language', lng);
});

export default i18n;
